import { createSelector } from "reselect";

import getViewer from "../base_getters/get_viewer";

export const getBuiltToNotBuiltConfirmationDialogOpen = createSelector([
  getViewer
], (viewer) => {
  return !!viewer.builtToNotBuiltConfirmationDialogOpen;
});
